/**
 * @generated SignedSource<<0011c1f39ab52eae097991e2dded9ec5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductRegistrationType = "application" | "closed" | "open" | "waitlist" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InvitationFormMemberFieldsFragment$data = {
  readonly id: string;
  readonly registrationPricing: {
    readonly basePrice: number;
  } | null;
  readonly registrationType: ProductRegistrationType;
  readonly slug: string;
  readonly " $fragmentType": "InvitationFormMemberFieldsFragment";
};
export type InvitationFormMemberFieldsFragment$key = {
  readonly " $data"?: InvitationFormMemberFieldsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitationFormMemberFieldsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitationFormMemberFieldsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RegistrationPricing",
      "kind": "LinkedField",
      "name": "registrationPricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basePrice",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "9a713edaa3d2736c001218d4c2178514";

export default node;
